module.exports = __webpack_public_path__ + "img/W-G45.e77a6ed3.jpg";